'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapImage8Bit;

var _pixelBppMap = require('./pixelBppMap');

var _pixelBppMap2 = _interopRequireDefault(_pixelBppMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapImage8Bit(_ref) {
  var image = _ref.image,
      pxData = _ref.pxData,
      getPxPos = _ref.getPxPos,
      bpp = _ref.bpp,
      data = _ref.data,
      rawPos = _ref.rawPos;

  var imageWidth = image.width;
  var imageHeight = image.height;
  var imagePass = image.index;
  for (var y = 0; y < imageHeight; y++) {
    for (var x = 0; x < imageWidth; x++) {
      var pxPos = getPxPos(x, y, imagePass);

      for (var i = 0; i < 4; i++) {
        var idx = _pixelBppMap2.default[bpp][i];
        if (idx === 0xff) {
          pxData[pxPos + i] = 0xff;
        } else {
          var dataPos = idx + rawPos;
          if (dataPos === data.length) {
            // eslint-disable-line
            throw new Error('Ran out of data');
          }
          pxData[pxPos + i] = data[dataPos];
        }
      }
      rawPos += bpp; //eslint-disable-line no-param-reassign
    }
  }
  return rawPos;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/dataToBitMap/mapImage8Bit.js
// module id = 1089
// module chunks = 0